/* Source interactions and Shopify product cart integration. */
(() => {
  const gallery = document.querySelector('.product-gallery');
  if (gallery) {
    const main = [...gallery.querySelectorAll('.shop-image-zoom-wrapper[data-media-id]')];
    const thumbs = [...gallery.querySelectorAll('.shop-thumbnail[data-media-id]')];
    let active = 0;
    const show = (index) => {
      active = (index + main.length) % main.length;
      main.forEach((item, i) => {
        item.classList.toggle('active', i === active);
        item.querySelectorAll('.shop-main-image').forEach((img) => img.classList.toggle('active', i === active));
      });
      thumbs.forEach((item, i) => {
        item.classList.toggle('active', i === active);
        item.setAttribute('aria-current', i === active ? 'true' : 'false');
      });
      thumbs[active]?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    };
    thumbs.forEach((item, i) => {
      item.setAttribute('role', 'button');
      item.setAttribute('tabindex', '0');
      item.setAttribute('aria-label', `Afficher l'image ${i + 1}`);
      item.addEventListener('click', () => show(i));
      item.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); show(i); }
      });
    });
    gallery.querySelectorAll('[class*="prev-arrow"]').forEach((button) => button.addEventListener('click', () => show(active - 1)));
    gallery.querySelectorAll('[class*="next-arrow"]').forEach((button) => button.addEventListener('click', () => show(active + 1)));
    show(active);
  }

  // Recreate the source card flip. The saved source frame had a fixed height
  // from an open card, which clipped the longer French back face.
  document.querySelectorAll('#ovf-benefits').forEach((root) => {
    const items = [...root.querySelectorAll('.bitem')];
    const height = (item, side) => item.querySelector(side).offsetHeight;
    const sync = () => items.forEach((item) => {
      item.style.height = `${height(item, item.classList.contains('flipped') ? '.bback' : '.bfront')}px`;
    });
    const setOpen = (target) => {
      items.forEach((item) => {
        const open = item === target;
        item.classList.toggle('flipped', open);
        const front = item.querySelector('.bfront');
        const back = item.querySelector('.bback');
        front.setAttribute('aria-expanded', String(open));
        front.tabIndex = open ? -1 : 0;
        back.setAttribute('aria-hidden', String(!open));
        back.tabIndex = open ? 0 : -1;
      });
      sync();
    };
    items.forEach((item) => {
      item.querySelector('.bfront').addEventListener('click', () => setOpen(item.classList.contains('flipped') ? null : item));
      item.querySelector('.bback').addEventListener('click', () => setOpen(null));
    });
    setOpen(null);
    window.addEventListener('resize', sync);
    window.addEventListener('load', sync);
  });

  // Source accordion behavior, measured after French copy has laid out.
  document.querySelectorAll('.ovp [data-ovp]').forEach((root) => {
    const items = [...root.querySelectorAll('.pitem')];
    const setOpen = (target) => items.forEach((item) => {
      const open = item === target;
      const answer = item.querySelector('.pa');
      item.classList.toggle('open', open);
      item.querySelector('.pq').setAttribute('aria-expanded', String(open));
      answer.style.maxHeight = open ? `${answer.scrollHeight}px` : '0px';
      item.querySelector('.pm').textContent = open ? '−' : '+';
    });
    items.forEach((item) => item.querySelector('.pq').addEventListener('click', () => {
      setOpen(item.classList.contains('open') ? null : item);
    }));
    setOpen(items[0] || null);
    window.addEventListener('resize', () => {
      const answer = root.querySelector('.pitem.open .pa');
      if (answer) answer.style.maxHeight = `${answer.scrollHeight}px`;
    });
  });

  document.querySelectorAll('.testimonials-carousel').forEach((carousel) => {
    const track = carousel.querySelector('.testimonials-track');
    const cards = [...track.querySelectorAll('.testimonial-card:not(.testimonial-clone)')];
    const dots = [...carousel.querySelectorAll('.testimonials-dots .dot')];
    if (!cards.length) return;
    let active = 0;
    let touchStart = null;
    const show = (index) => {
      active = (index + cards.length) % cards.length;
      const first = track.querySelector('.testimonial-card');
      const card = cards[active];
      const x = carousel.clientWidth / 2 - (card.offsetLeft - first.offsetLeft + card.offsetWidth / 2);
      track.style.transition = 'transform .35s cubic-bezier(.4,0,.2,1)';
      track.style.transform = `translateX(${Math.round(x)}px)`;
      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === active);
        dot.setAttribute('aria-current', String(i === active));
      });
    };
    dots.forEach((dot, index) => dot.addEventListener('click', () => show(index)));
    carousel.addEventListener('touchstart', (event) => { touchStart = event.changedTouches[0].clientX; }, { passive: true });
    carousel.addEventListener('touchend', (event) => {
      if (touchStart === null) return;
      const delta = event.changedTouches[0].clientX - touchStart;
      if (Math.abs(delta) > 40) show(active + (delta < 0 ? 1 : -1));
      touchStart = null;
    }, { passive: true });
    carousel.setAttribute('tabindex', '0');
    carousel.setAttribute('aria-label', 'Avis clients');
    carousel.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        show(active + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    window.addEventListener('resize', () => show(active));
    show(0);
  });

  document.querySelectorAll('.kaching-bundles__bar[data-bundle-quantity]').forEach((bar) => {
    const radio = bar.querySelector('input[type="radio"]');
    const activate = () => {
      radio.checked = true;
      const quantity = Number(bar.dataset.bundleQuantity);
      const form = document.querySelector('form[data-seleva-product-form]');
      const quantityInput = form?.querySelector('input[name="quantity"]');
      if (quantityInput && (quantity === 2 || quantity === 4)) quantityInput.value = String(quantity);
      const total = `${bar.dataset.bundleTotal} €`;
      const savings = `${bar.dataset.bundleSavings} €`;
      document.querySelectorAll('.kaching-bundles__bar[data-bundle-quantity]').forEach((other) => {
        other.classList.toggle('kaching-bundles__bar--selected', other === bar);
      });
      document.querySelectorAll('.kaching-bundles-savings-summary__value').forEach((node) => { node.textContent = savings; });
      document.querySelectorAll('.totals__total-value').forEach((node) => { node.textContent = total; });
      document.querySelectorAll('.shop-add-to-cart-button').forEach((button) => {
        button.dataset.originalText = `Commander — ${total}`;
        button.dataset.persistentText = `Commander — ${total}`;
      });
    };
    radio.addEventListener('change', activate);
    bar.querySelector('.kaching-bundles__bar-main')?.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); activate(); }
    });
  });

  const countdown = document.querySelector('.announcement-bar[data-countdown="midnight-local"]');
  if (countdown) {
    const update = () => {
      const now = new Date();
      const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      const secondsLeft = Math.max(0, Math.ceil((midnight - now) / 1000));
      const parts = {
        hours: Math.floor(secondsLeft / 3600),
        minutes: Math.floor(secondsLeft % 3600 / 60),
        seconds: secondsLeft % 60,
      };
      Object.entries(parts).forEach(([key, value]) => {
        const node = countdown.querySelector(`.time.${key}`);
        if (node) node.textContent = String(value).padStart(2, '0');
      });
    };
    update();
    setInterval(update, 1000);
  }

  document.querySelectorAll('.store-faq-question').forEach((question) => {
    const answer = question.nextElementSibling;
    if (!answer?.classList.contains('store-faq-answer')) return;
    question.setAttribute('role', 'button');
    question.setAttribute('tabindex', '0');
    question.setAttribute('aria-expanded', 'false');
    const toggle = () => {
      const open = question.getAttribute('aria-expanded') !== 'true';
      question.setAttribute('aria-expanded', String(open));
      question.closest('.store-faq-item')?.classList.toggle('active', open);
      answer.style.maxHeight = open ? `${answer.scrollHeight}px` : '0px';
      const sign = question.querySelector('.store-faq-toggle');
      if (sign) sign.textContent = open ? '−' : '+';
    };
    question.addEventListener('click', toggle);
    question.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); toggle(); }
    });
  });

  window.addToCartSticky = () => {
    document.getElementById('buybox')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  const productForm = document.querySelector('form[data-seleva-product-form]');
  const cartDrawer = document.createElement('div');
  cartDrawer.id = 'seleva-cart-drawer';
  cartDrawer.className = 'seleva-cart-drawer';
  cartDrawer.setAttribute('aria-hidden', 'true');
  cartDrawer.innerHTML = `<div class="seleva-cart-drawer__shade" data-seleva-close></div>
    <aside class="seleva-cart-drawer__panel" role="dialog" aria-modal="true" aria-label="Votre panier" tabindex="-1">
      <header class="seleva-cart-drawer__header"><h2>Votre panier</h2><button type="button" class="seleva-cart-drawer__close" data-seleva-close aria-label="Fermer le panier">×</button></header>
      <p class="seleva-cart-drawer__status" role="status"></p>
      <div class="seleva-cart-drawer__items"></div>
      <footer class="seleva-cart-drawer__footer"><div class="seleva-cart-drawer__total"><span>Total du panier</span><strong></strong></div>
        <form class="seleva-cart-drawer__checkout" method="post"><button type="submit" name="checkout">Passer au paiement</button></form>
        <button type="button" class="seleva-cart-drawer__continue" data-seleva-close>Continuer mes achats</button>
      </footer>
    </aside>`;
  document.body.append(cartDrawer);
  let drawerReturnFocus = null;
  const closeDrawer = () => {
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('seleva-cart-open');
    drawerReturnFocus?.focus();
  };
  cartDrawer.querySelectorAll('[data-seleva-close]').forEach((control) => control.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && cartDrawer.classList.contains('is-open')) closeDrawer();
  });
  // Shopify can render the French product at /fr-fr/ while routes.root_url is /.
  // The form action is localized by Shopify, so use it for every Ajax cart route.
  const cartAddPath = new URL(productForm?.action || '/cart/add', window.location.origin).pathname;
  const root = cartAddPath.replace(/cart\/add\/?$/, '');
  cartDrawer.querySelector('form').action = `${root}cart`;
  const money = (amount, currency) => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: currency || 'EUR' }).format(amount / 100);
  const fetchCart = async () => {
    const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Le panier ne peut pas être affiché.');
    return response.json();
  };
  const removeCartGroup = async (bundleId, lineKey) => {
    const status = cartDrawer.querySelector('.seleva-cart-drawer__status');
    status.textContent = 'Suppression en cours…';
    try {
      let cart = await fetchCart();
      for (let attempt = 0; attempt < 12; attempt += 1) {
        const target = cart.items.find((item) => bundleId
          ? item.properties?._bundle_id === bundleId
          : item.key === lineKey);
        if (!target) break;
        const response = await fetch(`${root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: target.key, quantity: 0 }),
        });
        if (!response.ok) throw new Error('La suppression a échoué. Réessayez.');
        cart = await fetchCart();
      }
      if (cart.items.some((item) => bundleId
        ? item.properties?._bundle_id === bundleId
        : item.key === lineKey)) {
        throw new Error('Certains articles sont encore dans le panier.');
      }
      renderCart(cart);
    } catch (error) {
      status.textContent = error.message || 'La suppression a échoué. Réessayez.';
    }
  };
  const renderCart = (cart) => {
    const items = cartDrawer.querySelector('.seleva-cart-drawer__items');
    items.replaceChildren();
    const groups = new Map();
    cart.items.forEach((item) => {
      const bundleId = item.properties?._bundle_id;
      const groupKey = bundleId || item.key;
      if (!groups.has(groupKey)) groups.set(groupKey, { bundleId, lineKey: item.key, lines: [] });
      groups.get(groupKey).lines.push(item);
    });
    groups.forEach(({ bundleId, lineKey, lines }) => {
      const item = lines[0];
      const row = document.createElement('div');
      row.className = 'seleva-cart-drawer__item';
      if (item.image) {
        const img = document.createElement('img');
        img.src = item.image;
        img.alt = item.product_title || 'NAC Liposomale';
        img.loading = 'lazy';
        row.append(img);
      }
      const details = document.createElement('div');
      const title = document.createElement('strong');
      title.textContent = item.product_title;
      const quantity = document.createElement('span');
      quantity.textContent = `Quantité : ${lines.reduce((sum, line) => sum + line.quantity, 0)}`;
      const price = document.createElement('span');
      price.textContent = money(lines.reduce((sum, line) => sum + line.final_line_price, 0), cart.currency);
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'seleva-cart-drawer__remove';
      remove.textContent = '×';
      remove.setAttribute('aria-label', `Supprimer ${item.product_title} du panier`);
      remove.addEventListener('click', () => removeCartGroup(bundleId, lineKey));
      details.append(title, quantity, price);
      row.append(details, remove);
      items.append(row);
    });
    cartDrawer.querySelector('.seleva-cart-drawer__status').textContent = `${cart.item_count} article${cart.item_count > 1 ? 's' : ''} dans votre panier`;
    cartDrawer.querySelector('.seleva-cart-drawer__total strong').textContent = money(cart.total_price, cart.currency);
    cartDrawer.querySelector('.seleva-cart-drawer__checkout button').disabled = cart.item_count === 0;
  };
  const openDrawer = (trigger) => {
    drawerReturnFocus = trigger;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('seleva-cart-open');
    cartDrawer.querySelector('.seleva-cart-drawer__close').focus();
  };
  productForm?.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = productForm.querySelector('button[type="submit"]');
    const message = document.getElementById('seleva-cart-message');
    const variantId = productForm.querySelector('input[name="id"]')?.value;
    const quantity = Number(productForm.querySelector('input[name="quantity"]')?.value);
    if (!variantId || ![2, 4].includes(quantity)) {
      if (message) message.textContent = 'Veuillez sélectionner une offre.';
      return;
    }
    button.disabled = true;
    if (message) message.textContent = 'Ajout au panier…';
    try {
      const bundleId = `seleva-${Date.now()}-${Math.random().toString(36).slice(2)}`;
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity, properties: { _bundle_id: bundleId } }),
      });
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || 'Ce produit ne peut pas encore être ajouté au panier.');
      }
      renderCart(await fetchCart());
      if (message) message.textContent = '';
      openDrawer(button);
    } catch (error) {
      if (message) message.textContent = error.message || 'Ajout impossible. Veuillez réessayer.';
    } finally {
      button.disabled = false;
    }
  });
})();
